import React from 'react'
import { useTranslation } from 'i18n'
import * as styles from './Countdown.module.scss'
import getClassNameFactory from '../../util/getClassNameFactory'

const getClassName = getClassNameFactory('Countdown', styles)
const getCountdownTimerClassName = getClassNameFactory('CountdownTimer', styles)
const getCountdownTimeClassName = getClassNameFactory('CountdownTime', styles)
const getCountdownTotalClassName = getClassNameFactory('CountdownTotal', styles)
const getCountdownProgressClassName = getClassNameFactory(
  'CountdownProgress',
  styles,
)
const getCountdownLabelNumberClassName = getClassNameFactory(
  'CountdownLabelNumber',
  styles,
)
const getCountdownLabelClassName = getClassNameFactory('CountdownLabel', styles)

const Countdown = ({
  currentTime,
  complete,
  // Callers may pass their own copy (the trivia step does); otherwise fall back
  // to the localized defaults rather than hardcoded English constants.
  completeLabel,
  progressLabel,
  questionDuration = 90,
  sponsoredType,
}) => {
  const { t } = useTranslation('shared')
  let progressBarWidth = Math.floor((currentTime / questionDuration) * 100)

  const completeText = completeLabel ?? t('countdown.congratsFoundAll')
  const progressText = progressLabel ?? t('countdown.betterLuckNextTime')
  const timeLabel = t('countdown.timeUnit', { count: currentTime })
  return (
    <div className={getClassName()}>
      {currentTime === 0 || complete ? (
        <div className={getCountdownLabelClassName()}>
          {complete ? completeText : progressText}
        </div>
      ) : (
        <div
          className={getCountdownTimerClassName({
            sponsored: sponsoredType === 'sponsored',
          })}
        >
          <div className={getCountdownTotalClassName()}>
            <div
              className={getCountdownProgressClassName()}
              style={{ width: progressBarWidth + '%' }}
            ></div>
          </div>
          <div className={getCountdownTimeClassName()}>{currentTime}</div>
          <div className={getCountdownLabelNumberClassName()}>{timeLabel}</div>
        </div>
      )}
    </div>
  )
}

export default Countdown
